module.exports = __webpack_public_path__ + "img/card-bg.41ce9032.png";